import React, { useEffect, useState } from 'react';
import * as Scrivito from 'scrivito';
import { findHomepage } from '../lib/homepage';

function getNavItems(homepage) {
  const body = homepage.get('body') || [];
  return body
    .filter((w) => {
      const cls = w.objClass();
      return (
        (cls === 'ContainerWidget' || cls === 'OurServicesWidget') &&
        w.get('includeInNav') !== 'nein'
      );
    })
    .map((w) => ({
      sectionName: w.get('sectionName') || '',
      title: w.get('title') || '',
    }))
    .filter((item) => item.sectionName);
}

const Navigation = Scrivito.connect(({ page }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const homepage = findHomepage(page);
  const navItems = homepage ? getNavItems(homepage) : [];
  const homepages = Scrivito.Obj.where('_objClass', 'equals', 'Homepage').toArray();

  return (
    // `expand-sm`: Bootstrap 3 collapsed the navbar below 768px, and with BS3's
    // breakpoint map compiled into Bootstrap (see styles/main.scss) `sm` is that
    // 768px, so on a tablet the old site still showed the full menu.
    <nav className={`navbar navbar-expand-sm navbar-dark tt-navbar fixed-top${scrolled ? ' tt-navbar--scrolled' : ''}`}>
      <div className="container">
        <a className="navbar-brand" href={homepage ? Scrivito.urlFor(homepage) : '/'}>
          trans-tech
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          aria-label="Toggle navigation"
        >
          {/* Bootstrap 3's three icon bars, as in the Rails template – BS5's
              .navbar-toggler-icon is a larger SVG and made the bar taller. */}
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
        </button>

        <div className={`collapse navbar-collapse ${open ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto">
            {navItems.map((item) => (
              <li key={item.sectionName} className="nav-item">
                <a
                  href={`#${item.sectionName}`}
                  className="nav-link"
                  onClick={() => setOpen(false)}
                >
                  {item.title}
                </a>
              </li>
            ))}

            {/* Language picker. The Rails app used a dropdown labelled with the
                homepage's `menuLanguage` ("Sprache" / "Language") listing every
                Homepage with its flag. Inline flag pills replaced it, which
                pushed the burger button off screen on phones. */}
            {homepages.length > 1 && homepage && (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {/* The HAML put the label on its own line and the caret on the
                      next, so a space sat on either side of it – 7px that are
                      part of the link's width. */}
                  {' '}
                  {homepage.get('menuLanguage') || 'Language'}
                  {' '}
                </a>
                <ul className="dropdown-menu dropdown-menu-end">
                  {homepages.map((hp) => (
                    <li key={hp.id()}>
                      <a className="dropdown-item" href={Scrivito.urlFor(hp)}>
                        <img
                          className="flag-icon"
                          src={`/flags/${hp.get('country') || 'Germany'}.png`}
                          alt={
                            hp.get('countryNameTranslation') ||
                            hp.get('menuLanguage') ||
                            hp.get('country') ||
                            ''
                          }
                          loading="lazy"
                        />
                        {hp.get('countryNameTranslation') || ''}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
});

export default Navigation;
